<template>
    <b-card class="detail-card mb-0" header-class="rainValueGather10-card-bg" header-text-variant="white">
        <template #header>
            <h4 class="font-weight-bold">
                {{ `${point.name}` }}
            </h4>
            <div>
                {{ `(${point.lat}, ${point.long})` }}
            </div>
        </template>
        <div style="display: flex; justify-content: space-between;">
            <DatePicker v-model="range" range lang="vi" format="DD/MM/YYYY" name="time" :shortcuts="shortcuts">
            </DatePicker>
            <v-select style="width: 240px;" v-model="type" class="ml-2" :options="typeOptions" :clearable="false"
                :filterable="false" :searchable="false"></v-select>
        </div>
        <b-overlay :show="isLoading" spinner-variant="primary" variant="light" opacity="0.5" blur="1px" rounded="sm">
            <b-row class="mt-2">
                <b-col cols="12" v-for="(item, index) in listMap" :key="item.name">
                    <BarChartStatistic v-if="point.chartType === 'bar'" :series="listStatistic[index]"
                        :title="item.name" :unit="unit" :type="item.value" />
                    <LineChartStatistic v-if="point.chartType === 'line'" :series="listStatistic[index]"
                        :title="item.name" :unit="unit" :type="item.value" />
                </b-col>
            </b-row>
        </b-overlay>
    </b-card>
</template>

<script>
import { mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import BarChartStatistic from '@/components/BarChartStatistic';
import LineChartStatistic from '@/components/LineChartStatistic';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
import { getRange } from '../utils/datetime';

export default {
    components: {
        DatePicker,
        BarChartStatistic,
        LineChartStatistic
    },
    async mounted() {
        await this.$nextTick();
        this.typeOptions = await this.getDataType();
        if (this.typeOptions.length === 0) return;
        this.type = this.typeOptions[0];
        this.range = getRange(7);
        this.getData();
    },
    props: {
        point: {
            type: Object,
            required: true
        },
    },
    data: function () {
        return {
            shortcuts: [
                {
                    text: '1 tuần qua',
                    onClick() {
                        return getRange(7);
                    }
                },
                {
                    text: '2 tuần qua',
                    onClick() {
                        return getRange(14);
                    }
                },
                {
                    text: '1 tháng qua',
                    onClick() {
                        return getRange(31);
                    }
                },
                {
                    text: '2 tháng qua',
                    onClick() {
                        return getRange(61);
                    }
                },
                {
                    text: '3 tháng qua',
                    onClick() {
                        return getRange(92);
                    }
                },
                {
                    text: '6 tháng qua',
                    onClick() {
                        return getRange(183);
                    }
                },
                {
                    text: '1 năm qua',
                    onClick() {
                        return getRange(365);
                    }
                }
            ],
            range: [],
            unit: '',
            typeOptions: [],
            type: null,
            isLoading: false,
            listMap: [
                {
                    name: 'Theo thời gian',
                    value: 'flex'
                }
            ],
            listStatistic: [[]]
        };
    },
    watch: {
        range() {
            this.getData();
        },
        type(value) {
            this.getData();
        }
    },
    methods: {
        ...mapActions({
            getStatisticFlex: 'statistic/flex',
            getDataType: 'data/getDataType'
        }),
        async getData() {
            this.isLoading = true;
            try {
                const params = { pointId: this.point.id, type: this.type };
                if (this.range.length === 2) {
                    params.from = this.range[0];
                    params.to = this.range[1];
                }
                const list = await Promise.all([this.getStatisticFlex(params)]);
                for (let i = 0; i < this.listStatistic.length; i++) {
                    this.listStatistic[i] = [{ name: this.point.name, data: list[i] }];
                }
            } catch (error) { }
            this.isLoading = false;
        }
    }
};
</script>
<style>
.mx-datepicker-sidebar {
    width: 120px;
}

.v-select .vs__selected-options {
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
}
</style>
